import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ArticoliService} from "../../../_services/articoli.service";
import {ArticoloCiclo} from "../../../_models/ArticoloCiclo";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {SearchResult} from "../../../_models/SearchResult";
import {SaveMessage} from "../../../_helpers/save-message";

@Component({
  selector: 'app-articolo-ciclo-input',
  templateUrl: './articolo-ciclo-input.component.html',
  styleUrls: ['./articolo-ciclo-input.component.scss'],
  standalone: false
})
export class ArticoloCicloInputComponent {
  @Input() codArt = '';
  @Output() cicloChange = new EventEmitter<ArticoloCiclo>();
  ciclo: ArticoloCiclo[] = [];
  codCiclo = '';
  codLav = '';
  showCiclo = false;
  loading = false;

  constructor(
    private organizzazioneService: OrganizzazioniService,
    private articoliService: ArticoliService,
    private saveMessage: SaveMessage
  ) { }


  getCiclo = () => {
    this.showCiclo = !this.showCiclo;
    if (!this.showCiclo) {
      this.ciclo = [];
      return false;
    }
    this.loading = true;
    this.articoliService.searchCicloOfArticolo(this.organizzazioneService.organizzazioneId, this.codArt, 0, 0)
      .then((_ciclo: SearchResult<ArticoloCiclo>) => {
        if (_ciclo.totalCount > 0) {
          this.ciclo = _ciclo.result;
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento del ciclo."))
      .finally(() => this.loading = false);
  }

  selectCiclo = (ciclo: ArticoloCiclo) => {
    if (!ciclo || !ciclo.codCiclo) {
      return false;
    }
    this.showCiclo = false;
    this.ciclo = [];
    this.codCiclo = ciclo.codCiclo;
    this.codLav = ciclo.codLavorazione;
    this.cicloChange.emit(ciclo);
  };
}
